import AppTitle from '../support/AppTitle.js';
import useAuth from '../auth/useAuth.js';
import LoginSSO from './LoginSSO.js';

import React, { useState } from 'react';
import useAnalytics from '../support/Analytics.js';
import { Helmet } from "react-helmet";
import { useLocation, useHistory } from 'react-router';
import { Link } from "react-router-dom";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField'

const Login = (props) => {
    const { embed, open, onLogin, canCancel, message, homeButton } = props;
    const [loading, setLoading] = useState(false);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [showError, setShowError] = useState(false);
    const analytics = useAnalytics();

    let history = useHistory();
    let location = useLocation();
    let auth = useAuth();
    let { from } = location.state || { from: { pathname: "/" } };
    
    let login = () => {
        auth.signin(username, password)
            .then((response) => {
                setLoading(false);
                setShowError(false);
                if (!embed) {
                    history.replace(from == "/login" ? "/" : from);
                } else {
                    if(onLogin) onLogin(true);
                }
                analytics.tag('event', 'login', { method: 'default' });
            })
            .catch((error) => {
                console.log(error);
                setShowError(true);
                if (error.response) {
                    setErrorMessage(error.response.data.message);
                }
                setLoading(false);
            });
    };

    const handleLogin = (e) => {
        e.preventDefault();
        setLoading(true);
        login();
    }
    const handleEditClose = () => {
        if(onLogin) onLogin(false);
    };
    const handleEnter = (e) => {
        if (e.which === 13) {
            handleLogin(e);
        }
    }

    const mainContent = () => {
        return (
            <React.Fragment>
                <LoginSSO />
                <p>{message ? message : "Please login using your UOW username and password."}</p>
                <TextField autoComplete="username" type="text" onChange={(e) => setUsername(e.target.value)} autoFocus label="Username/email" fullWidth={embed} onKeyPress={handleEnter} />
                <TextField autoComplete="current-password" type="password" onChange={(e) => setPassword(e.target.value)} label="Password" fullWidth={embed} onKeyPress={handleEnter} />
                {showError ? <p className="error">Something went wrong: {errorMessage} </p> : <span />}
            </React.Fragment>
        );
    };

    const mainButtons = () => {
        return (
            <React.Fragment>
                {homeButton ? <Link to="/home"><Button color="default">Cancel</Button></Link> : null }
                <Button type="submit" value={loading ? 'Logging you in...' : 'Login'} disabled={loading} color="primary" onClick={login}>Login</Button>
            </React.Fragment>
        );
    };

    return (
        <form onSubmit={(e) => handleLogin(e)} autoComplete="on">
            <div className="content">
                {embed ?
                    <Dialog open={open} onClose={handleEditClose} aria-labelledby="form-dialog-title">
                        <DialogTitle id="form-dialog-title">Login</DialogTitle>
                        <DialogContent>
                            {mainContent()}</DialogContent>
                        <DialogActions>
                            {mainButtons()}
                            {canCancel ? <Button onClick={handleEditClose} color="default">Cancel</Button> : null}
                        </DialogActions>
                    </Dialog>
                    :
                    <React.Fragment>
                        <Helmet><title>{AppTitle("Login")}</title></Helmet>
                        {mainContent()}
                        {mainButtons()}
                    </React.Fragment>
                }
            </div>
        </form>
    );
};

export default Login;